import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=38fdcefa&scoped=true"
import script from "./ReportDetails.vue?vue&type=script&lang=js"
export * from "./ReportDetails.vue?vue&type=script&lang=js"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=38fdcefa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fdcefa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38fdcefa')) {
      api.createRecord('38fdcefa', component.options)
    } else {
      api.reload('38fdcefa', component.options)
    }
    module.hot.accept("./ReportDetails.vue?vue&type=template&id=38fdcefa&scoped=true", function () {
      api.rerender('38fdcefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/MyBeans/ReportDetails.vue"
export default component.exports